
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'QaIcon',
  props: {
    name: {
      type: String,
      default: '',
    },
  },
});
